import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { request } from "@/js/http/http_request";
import { getFullNameUser } from "@/js/user/user.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import MicroDepositsDialog from "./MicroDepositsDialog.vue";
export default {
  name: "BankAccountListComponent",
  props: {
    isAch: {
      type: Boolean,
      default: false
    },
    isSepa: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    clientSecret: {
      type: String,
      default: ""
    },
    user: Object,
    stripe: Object,
    list: Array,
    numberOfPaymentMethods: Number
  },
  data: function data() {
    return {
      isValid: false,
      errorMessage: null,
      elements: null,
      bankAccountElement: null,
      isConnectingAch: false,
      achErrorOccurred: false,
      microDepositsUrl: null,
      microDepositsShown: false,
      stripeErrorOccured: false,
      setupIntent: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.generateStripeFields();
  },
  watch: {
    stripe: function stripe() {
      this.generateStripeFields();
    }
  },
  components: {
    confirm: confirmationComponent,
    MicroDepositsDialog: MicroDepositsDialog
  },
  methods: {
    deleteBankAccount: function deleteBankAccount(payment_method_id) {
      var _this = this;
      this.$refs.confirm.open("Delete", "Are you sure you want to delete this bank account ?", {
        color: "red"
      }).then(function (confirm) {
        if (confirm) {
          _this.$EventBus.$emit("loading", true);
          request("/v1/stripe/payment-method/" + payment_method_id, "delete", null, true, "api").then(function () {
            _this.$emit("bank-deleted");
          }).finally(function () {
            _this.$EventBus.$emit("loading", false);
          });
        }
      });
    },
    setDefaultPayment: function setDefaultPayment(bankAccount) {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      request("/v1/stripe/payment-method/".concat(bankAccount.payment_method_id, "/default"), "put", {}, true, "api").then(function () {
        _this.$emit("bank-updated");
      }).finally(function () {
        _this.$EventBus.$emit("loading", false);
      });
    },
    saveBankAccount: function saveBankAccount() {
      this.$EventBus.$emit("loading", true);
      var _this = this;
      this.stripe.confirmSepaDebitSetup(this.clientSecret, {
        payment_method: {
          sepa_debit: this.bankAccountElement,
          billing_details: {
            name: getFullNameUser(this.user),
            email: this.user.login,
            address: {
              line1: this.user.billing_address.street,
              country: this.user.billing_address.country.iso_2
            }
          }
        }
      }).then(function (result) {
        var setupIntent = result.setupIntent;
        if (result.error) {
          _this.errorMessage = result.error.message;
          throw result.error.message;
        } else if (setupIntent.status === "requires_payment_method") {
          throw "Confirmation failed. Attempt again with a different payment method.";
        } else if (setupIntent.status === "succeeded") {
          request("/v1/stripe/payment-method", "post", {
            payment_method_id: result.setupIntent.payment_method,
            customerId: _this.user.id_user
          }, true, "api").then(function () {
            _this.$emit("bank-saved");
            _this.bankAccountElement.clear();
          }).finally(function () {
            _this.$EventBus.$emit("loading", false);
          });
        }
      });
    },
    generateStripeFields: function generateStripeFields() {
      if (this.stripe && this.isSepa) {
        this.elements = this.stripe.elements({
          locale: "en"
        });
        var options = {
          style: {
            base: {
              padding: "20rem",
              textAlign: "center",
              color: "#000",
              fontWeight: 500,
              fontSize: "16px",
              fontSmoothing: "antialiased",
              ":-webkit-autofill": {
                color: "#000"
              },
              "::placeholder": {
                color: "#CFD7DF"
              }
            },
            invalid: {
              color: "#FFC7EE",
              ":focus": {
                color: "#000"
              }
            }
          },
          supportedCountries: ["SEPA"]
        };
        this.bankAccountElement = this.elements.create("iban", options);
        this.bankAccountElement.mount("#bank-account-element");
        var _this = this;
        this.bankAccountElement.on("ready", function () {
          _this.bankAccountElement.focus();
        });
        this.bankAccountElement.on("change", function (e) {
          if (e.complete) {
            _this.$parent.$data.stripeErrorOccured = false;
            _this.$emit("input", 0);
            _this.isValid = true;
          } else {
            _this.isValid = false;
          }
          if (e.error) {
            _this.errorMessage = e.error.message;
            _this.isValid = false;
          } else {
            _this.errorMessage = null;
          }
        });
      }
    },
    connectAch: function connectAch() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.isConnectingAch = true;
              _this = _this2;
              _this2.stripe.collectBankAccountForSetup({
                clientSecret: _this2.clientSecret,
                params: {
                  payment_method_type: "us_bank_account",
                  payment_method_data: {
                    billing_details: {
                      name: getFullNameUser(_this2.user),
                      email: _this2.user.login
                    }
                  }
                },
                expand: ["payment_method"]
              }).then(function (_ref) {
                var setupIntent = _ref.setupIntent,
                  error = _ref.error;
                if (error) {
                  _this.isConnectingAch = false;
                } else if (setupIntent.status === "requires_payment_method") {
                  _this.isConnectingAch = false;
                } else if (setupIntent.status === "requires_confirmation") {
                  _this.stripe.confirmUsBankAccountSetup(_this.clientSecret).then(/*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
                      var _setupIntent$next_act;
                      var setupIntent, error;
                      return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while (1) switch (_context.prev = _context.next) {
                          case 0:
                            setupIntent = _ref2.setupIntent, error = _ref2.error;
                            if (error) {
                              _this.stripeErrorOccured = true;
                              _this.achErrorOccurred = true;
                            } else if (setupIntent.status === "requires_payment_method") {
                              _this.stripeErrorOccured = true;
                              _this.achErrorOccurred = true;
                            } else if (setupIntent.status === "succeeded" || setupIntent.status === "processing") {
                              _this.stripeErrorOccured = false;
                              _this.setupIntent = setupIntent;
                              _this.saveUsBankAccount();
                            } else if (((_setupIntent$next_act = setupIntent.next_action) === null || _setupIntent$next_act === void 0 ? void 0 : _setupIntent$next_act.type) === "verify_with_microdeposits") {
                              _this.microDepositsUrl = setupIntent.next_action.verify_with_microdeposits.hosted_verification_url;
                              _this.setupIntent = setupIntent;
                              _this.microDepositsShown = true;
                            }
                            _this.isConnectingAch = false;
                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }, _callee);
                    }));
                    return function (_x) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (message) {
                    _this.$EventBus.$emit("loading", false);
                    _this.$toasted.show(message, {
                      type: "warning"
                    });
                  });
                }
              });
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    continueSaveFromDeposits: function continueSaveFromDeposits(callback) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.saveUsBankAccount();
            case 2:
              callback();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    saveUsBankAccount: function saveUsBankAccount() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.$EventBus.$emit("loading", true);
              _this = _this4;
              _context4.next = 4;
              return request("/v1/stripe/payment-method", "post", {
                customerId: _this4.user.id_user,
                payment_method_id: _this4.setupIntent.payment_method
              }, true, "api").then(function () {
                _this.$emit("bank-saved");
              });
            case 4:
              _this4.$EventBus.$emit("loading", false);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};